import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = (data) =>
  request.post(
    'Acceptance/create_acceptance',
    data,
    'Не удалось создать приемку',
    'Error'
  );

export const useCreateAcceptanceMutation = (options) =>
  useMutation(mutationFn, options);
